export default "__VITE_ASSET__DMXoPrwS__"